<template>
    <li
        class="d-sidebar-version-info"
    >
        <a
            class="nav-link c-sidebar-nav-link"
            :href="pipelineUri"
        >
            <b>{{ $t('sidebar.app_name') }}</b><br>
            <span v-if="sslToolVersion.pipelineId">
                <span>{{ $t('sidebar.build_number', { number: sslToolVersion.pipelineId }) }}</span><br>
                <span>{{ $t('sidebar.build_date', { date: buildDate }) }}</span><br>
            </span>
            <span v-if="sslToolVersion.tag">
                <span>{{ $t('sidebar.version', { version: sslToolVersion.tag }) }}</span><br>
            </span>
            <span v-else-if="sslToolVersion.branch">
                <span>{{ $t('sidebar.branch', { branch: sslToolVersion.branch }) }}</span><br>
            </span>
            <span v-if="environment === 'local'">{{ $t('sidebar.env_development') }}</span>
            <span v-else-if="environment === 'staging' || environment === 'stage'">{{ $t('sidebar.env_staging') }}</span>
            <span v-else>{{ $t('sidebar.env_production') }}</span>
        </a>
    </li>
</template>
<script>
import { usePage } from '@inertiajs/vue3'

export default {
    name: 'DSidebarVersionInfo',
    computed: {
        sslToolVersion () {
            return usePage()?.props?.sslToolVersion ?? {
                date: null,
                pipelineId: null
            }
        },
        environment () {
            return usePage()?.props?.environment
        },
        buildDate () {
            return new Date(this.sslToolVersion.date).toLocaleString('de')
        },
        pipelineUri () {
            return this.sslToolVersion.pipelineId
                ? 'https://git.dogado.net/crm/ssl-tool/-/pipelines/' + this.sslToolVersion.pipelineId
                : '#'
        }
    }
}
</script>

<style scoped lang="scss">
.c-sidebar-unfoldable{
    .d-sidebar-version-info {
        display: none;
    }
    &:hover{
        .d-sidebar-version-info{
            display: block;
        }
    }
}
.d-sidebar-version-info {
    font-size: 12px;
    color: var(--dark);
    margin-top: auto;

    .c-sidebar-nav-link{
        white-space: unset;
        display: block;
        *{
            white-space: nowrap;
        }
    }

}
</style>
